"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocumentScreenWithinLimit = exports.DOCUMENT_SCREEN_MAX_LENGTH = void 0;
/**
 * Instruction and completion screens are optional HTML an author can put in
 * front of, and after, a consent document. Cortex caps each at 50k characters
 * on both `ec__document_template` and `ec__published_studio_template`, so the
 * editor has to hold the same line — a longer value is rejected by the API
 * after the author has already written it.
 */
exports.DOCUMENT_SCREEN_MAX_LENGTH = 50000;
const isDocumentScreenWithinLimit = (html) => html.length <= exports.DOCUMENT_SCREEN_MAX_LENGTH;
exports.isDocumentScreenWithinLimit = isDocumentScreenWithinLimit;
//# sourceMappingURL=document_screens.js.map